import React from 'react';
import { Badge } from '../ui/Badge';

// Status vocabulary -> Badge tone. Anything unknown renders neutral.
const STATUS_TONES = {
    active: 'success',
    accepted: 'success',
    delivered: 'success',
    success: 'success',
    inactive: 'warning',
    pending: 'warning',
    retrying: 'warning',
    revoked: 'danger',
    failed: 'danger',
    expired: 'neutral',
};

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');

/**
 * One status pill for every table and detail view.
 *
 * Boolean form (most tables): `<StatusBadge active={row.is_active} />` -> "Active" / "Inactive".
 * Vocabulary form: `<StatusBadge status="pending" icon={Clock} />` -> tone from the status map,
 * label defaults to the capitalised status.
 *
 * @param {boolean} [active] boolean status; ignored when `status` is given
 * @param {string} [status] status keyword (active, pending, revoked, expired, failed, ...)
 * @param {string} [label] overrides the displayed text
 * @param {React.ComponentType} [icon] optional leading icon
 * @param {string} [title] tooltip (e.g. a delivery error)
 */
const StatusBadge = ({ active, status, label, icon: Icon, title }) => {
    const key = status ? String(status).toLowerCase() : active ? 'active' : 'inactive';
    const text = label || capitalize(key);
    return (
        <Badge variant={STATUS_TONES[key] || 'neutral'} shape="pill" title={title}>
            {Icon && <Icon aria-hidden="true" />}
            {text}
        </Badge>
    );
};

export default StatusBadge;
